import React from 'react';
import { Link } from 'gatsby';
import { IconTwitter, IconFacebook } from '~/icons';
import * as styles from './BlogFooter.module.scss';

const BlogFooter = () => {
  return (
    <footer className={styles.wrapper}>
      <div className={styles.bar}>
        <a href="https://www.facebook.com/aizulab" target="_blank" rel="noopener noreferrer" aria-label="会津ラボのFacebookページへ" className={styles.button}>
          <IconFacebook />
        </a>
        <a href="https://twitter.com/aizulab" target="_blank" rel="noopener noreferrer" aria-label="会津ラボのTwitterページへ" className={styles.button}>
          <IconTwitter />
        </a>
      </div>
      <div className={styles.nav}>
        <Link to="/contact">お問い合わせ</Link>
        <Link to="/privacy">個人情報保護方針</Link>
        <Link to="/company">会社情報</Link>
      </div>
      <p className={styles.copyright}>Copyright Aizu Laboratory, Inc.</p>
    </footer>
  )
}

export default React.memo(BlogFooter);